const hi = {
	login: 'लॉग इन करें',
	logout: 'लॉग आउट',
	signin: 'साइन इन करें',
	signup: 'साइन अप करें',
	email: 'ईमेल',
	emailAddr: 'ईमेल पता',
	password: 'कुंजिका',
	rememberMe: 'मुझे याद रखना',
	forgotYourPwd: 'अपना कूट शब्द भूल गए?',
	signinFacebook: 'फ़ेसबुक से साइन इन करें',
	signinGoogle: 'Google के साथ साइन इन करें',
	dontAccount: 'खाता नहीं है?',
	firstName: 'पहला नाम',
	lastName: 'उपनाम',
	confirmPwd: 'पासवर्ड की पुष्टि कीजिये',
	signup_msg: 'Join now पर क्लिक करके, आप इससे सहमत हैं',
	digitX_user_agreement: 'डिजिटएक्सचेंज यूजर एग्रीमेंट',
	privacy_policy: 'गोपनीयता नीति',
	and: ' तथा ',
	cookies_policy: 'कुकीज़ नीति',
	have_account: 'क्या आपके पास पहले से एक खाता मौजूद है',
	forgotPwd: 'पासवर्ड भूल गए',
	recoverPwd: 'गोपनीय शब्द पुन प्राप्त करे',
	forgotPwd_msg: 'अपना ईमेल ऊपर के क्षेत्र में रखें, हम आपको निर्देशों का पालन करने के लिए एक लिंक भेजेंगे।',
	changePwd: 'पासवर्ड बदलें',
	oldPwd: 'पुराना पासवर्ड',
	newPwd: 'नया पासवर्ड',
	confirmNewPwd: 'नए पासवर्ड की पुष्टि करें',
	user_account: 'उपभोक्ता खाता',
	change_pic: 'चित्र बदलो',
	mobile_number: 'मोबाइल नंबर',
	country: 'देश',
	update_settings: 'सेटिंग अपडेट करें',
	company: 'कंपनी',
	aboutUs: 'हमारे बारे में',
	tos: 'टीओएस',
	copyright: 'कॉपीराइट',
	socialMedia: 'सामाजिक मीडिया',
	forUpdates: 'अपडेट के लिए',
	footer_msg_1: 'साइन अप करके आप स्वीकार कर रहे हैं',
	terms: 'सेवा की शर्तें',
	contactUs: 'संपर्क करें',
	yourEmail: 'तुम्हारा ईमेल',
	required: 'अपेक्षित',
	yourMsg: 'आपका सन्देश',
	sent: 'भेज दिया',
	footer_msg_2: 'सर्वाधिकार सुरक्षित',
	footer_msg_3: 'सभी उत्पाद नाम, ट्रेडमार्क और पंजीकृत ट्रेडमार्क उनके संबंधित स्वामियों की संपत्ति हैं',
	doom: 'कयामत III',
	filter: 'फ़िल्टर',
	add_asset: 'संपत्ति जोड़ें',
	request_game: 'अनुरोध खेल',
	search_msg: 'क्षमा करें, लेकिन आपके खोज शब्दों से कुछ भी मेल नहीं खाता।',
	post: 'पद',
	asset: 'एसेट',
	create: 'सृजन करना',
	character: 'चरित्र',
	characters: 'पात्र',
	assets: 'संपत्ति',
	profile: 'प्रोफ़ाइल',
	game: 'खेल',
	games: 'खेल',
	currency: 'मुद्रा',
	store: 'दुकान',
	all_time: 'पूरा समय',
	this_month: 'इस महीने',
	trending: 'रुझान',
	item_name: 'वस्तु का नाम',
	view_item: 'आइटम देखें',
	leaderboard: 'लीडरबोर्ड',
	posters: 'पोस्टर',
	chinese: 'चीनी',
	english: 'अंग्रेज़ी',
	japanese: 'जापानी',
	korean: 'कोरियाई',
	german: 'जर्मन',
	french: 'फ्रेंच',
	spanish: 'स्पेनिश',
	italian: 'इतालवी',
	russian: 'रूसी',
	portuguese: 'पुर्तगाली',
	hindi: 'हिंदी',
	arabic: 'अरबी',
	buy: 'खरीदें',
	subscription: 'अंशदान',
	buy_subscription: 'सदस्यता खरीदें',
	gift: 'उपहार',
	xchange: 'Xchange',
	subscription_plan: 'सदस्यता योजना',
	payment_options: 'भुगतान विकल्प',
	cardholder_name: 'कार्डधारक का नाम',
	submit_order: 'आदेश प्रस्तुत',
	card_number: 'कार्ड नंबर',
	cvv: 'सीवीवी',
	expiration_date: 'समाप्ति तिथि',
	buyXchange: 'Xchange खरीदें',
	giftXchange: 'उपहार Xchange',
	or: 'या',
	select: 'चुनते हैं',

	search: 'खोज',
	search_games: 'खेलों की खोज करें ...',
	search_assets: 'एसेट्स खोजें ...',
	platform: 'मंच',
	total_posts: 'कुल पद',
	total_comments: 'कुल टिप्पणियाँ',
	total_characters: 'कुल वर्ण',
	total_assets: 'कुल संपत्ति',
	xchange_currency: 'Xchange Currency',
	subscription_days_remaining: 'सदस्यता के दिन शेष हैं',
	total_asset_networth: 'कुल संपत्ति नेटवर्थ',
	total_character_networth: 'कुल चरित्र नेटवर्थ',
	most_downloaded: 'सबसे ज्यादा डाउनलोड किया जाने वाला',
	recently_added: 'हाल ही में जोड़ा',
	genre: 'शैली',
	my_library: 'मेरा पुस्तकालय',
	most_commented: 'अधिकांश टिप्पणी',
	most_recent: 'सबसे हाल का',
	nearing_addition: 'जोड़ के पास',
	create_asset: 'एसेट बनाएं',
	create_character: 'चरित्र निर्मित करें',
	asset_name: 'एसेट नाम',
	asset_type: 'संपदा प्रकार',
	rarity: 'दुर्लभ वस्तु',
	enhancements: 'संवर्द्धन',
	add: 'जोड़ना',
	currency_type: 'मुद्रा प्रकार',
	price: 'कीमत',
	description: 'विवरण',
	upload_asset: 'एसेट अपलोड करें',
	preview_asset: 'एसेट का पूर्वावलोकन करें',
	main_image: 'मुख्य छवि',
	upload_video: 'विडियो को अॅॅपलोड करें',
	upload: 'डालना',
	view_demo: 'डेमो देखें',
	character_name: 'चरित्र का नाम',
	character_type: 'चरित्र प्रकार',
	upload_character: 'चरित्र अपलोड करें',
	preview_character: 'चरित्र का पूर्वावलोकन करें',
	race: 'दौड़',
	class: 'कक्षा',
	gender: 'लिंग',
	level: 'स्तर',
	showing: 'दिखा रहा है',
	of: 'का',
	results: 'परिणाम',
	featured_characters: 'चित्रित चरित्र',
	url: 'यूआरएल',
	submit: 'प्रस्तुत',
	real_world: 'असली दुनिया',
	game_currency: 'खेल मुद्रा',
	all: 'सब',

	edit: 'संपादित करें',
	save: 'सहेजें',
	agg_character_networth: 'एग्रीगेटेड कैरेक्टर नेटवर्थ',
	agg_time_played: 'एकत्र समय खेला गया',
	agg_asset_value: 'एग्रीगेटेड एसेट वैल्यू',
	enter_character_creation_date: 'चरित्र निर्माण दिनांक दर्ज करें',
	in_game_currency: 'खेल मुद्रा में',
	real_world_value: 'वास्तविक विश्व मूल्य',
	update_character: 'चरित्र को अद्यतन करें',
	item_not_found: 'वस्तु नहीं मिली!',
	ripper: 'आरा',
	comments: 'टिप्पणियाँ',
	add_comments: 'टिप्पणी करें',
	new_suggested_price: 'नई सुझाई गई कीमत',
	sort_by: 'इसके अनुसार क्रमबद्ध करें',
	reply: 'जवाब दे दो',
	asset_networth: 'एसेट नेटवर्थ',
	join_date: 'संलग्न तिथि',
	report: 'रिपोर्ट good',
	first: 'प्रथम',
	last: 'अंतिम',
	most_replies: 'ज्यादातर जवाब',
	new_pricing_recommendations: 'नई मूल्य निर्धारण सिफारिशें',
	xchange_amount: 'Xchange राशि',
	username: 'उपयोगकर्ता नाम',
	send_gift: 'उपहार भेजें',
	message: 'संदेश',
	gift_text: 'यहां अपना संदेश निजीकृत करें',
	day: 'दिन',
	days: 'दिन',
	currency_converter: 'मुद्रा परिवर्तक',
	from: 'से',
	to: 'सेवा',
	in_game: 'खेल में',
	real_life: 'असली जीवन',
	cvc: 'सीवीसी',
	card: 'कार्ड',
	per_month: 'मासिक ($ 3 प्रति माह)',
	per_year: 'वार्षिक ($ 30 प्रति वर्ष)',
	aboutUs_text: 'डिजिटएक्सचेंज एक समुदाय द्वारा संचालित वेबसाइट है जिसका उद्देश्य अंत में भीड़-सोर्सिंग के माध्यम से डिजिटल वस्तुओं और सेवाओं के मूल्य पर एक मूल्य रखना है। यदि आपने कभी यह सवाल पूछा है कि "मेरा चरित्र वास्तव में कितना योग्य है" या "मुझे आश्चर्य है कि एक अन्य खेल में एक अन्य खिलाड़ी के साथ एक निष्पक्ष व्यापार क्या होगा," जवाबों के लिए आगे मत देखो। हमें उम्मीद है कि आप हमारी साइट का आनंद लेंगे, समूह ज्ञान के निर्माण में भाग लेंगे, अपनी मेहनत की कमाई को दिखा सकते हैं और अंततः अपने कुल डिजिटल नेटवर्थ का पता लगाने के लिए तत्पर हैं!',
	home: 'मुखपृष्ठ',
	all_time_characters: 'सभी समय वर्ण',
	this_month_characters: 'इस महीने के चरित्र',
	trending_characters: 'चरित्रों का चलन',
	all_time_posters: 'ऑल टाइम पोस्टर',
	this_month_posters: 'इस महीने के पोस्टर',
	trending_posters: 'ट्रेंडिंग पोस्टर',
	
};

export default hi;


// WEBPACK FOOTER //
// ./src/translations/hi.js